import { useEffect, useState } from 'react'

const useBreakpoint = () => {
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)

  useEffect(() => {
    const handleSize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    handleSize()
    window.addEventListener('resize', handleSize)

    return () => window.removeEventListener('resize', handleSize)
  }, [])

  return { width, height }
}

export default useBreakpoint
